import React from 'react'
import clsx from 'clsx'

import { OutcomeTone } from '../types'
import { usePhoneStyles } from '../usePhoneStyles'

interface OutcomeChipProps {
    label: string
    tone: OutcomeTone
}

export const OutcomeChip: React.FC<OutcomeChipProps> = ({ label, tone }) => {
    const classes = usePhoneStyles()

    const toneClass =
        tone === 'positive'
            ? classes.outcomePositive
            : tone === 'negative'
            ? classes.outcomeNegative
            : tone === 'brand'
            ? classes.outcomeBrand
            : classes.outcomeNeutral

    return <span className={clsx(classes.outcomeChip, toneClass)}>{label}</span>
}
